import React from "react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer } from "recharts";

function TotalTransactionChart({ data, dataInner, color, mainKey }) {
  return (
    <ResponsiveContainer width="100%" height="100%" aspect={2}>
      <BarChart data={data}>
        <XAxis
          axisLine={false}
          tickLine={false}
          dataKey={dataInner}
          fontSize={9}
          fontWeight={500}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          fontSize={9}
          fontWeight={500}
          dataKey={mainKey}
          tickFormatter={function (val) {
            return Math.abs(val) > 999999999
              ? `${(mainKey === "amount" && "₦") || ""}${
                  Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)
                }B`
              : Math.abs(val) > 999999
              ? `${(mainKey === "amount" && "₦") || ""}${
                  Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)
                }M`
              : Math.abs(val) > 999
              ? `${(mainKey === "amount" && "₦") || ""}${
                  Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)
                }k`
              : Math.sign(val) * Math.abs(val);
          }}
        />
        <Bar
          dataKey={mainKey}
          stackId="a"
          fill={color}
          radius={[10, 10, 0, 0]}
          barSize={12}
        />
        <Bar
          dataKey="available"
          stackId="a"
          fill="#DFE4EB"
          radius={[10, 10, 0, 0]}
          barSize={12}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default TotalTransactionChart;
